<template>
    <button :class="['submit-button']" @click.prevent="$emit('submit')">
        <LoadingSpinner v-if="submitting" key="loading-spinner" color="#fff" />
        <span v-else>
            {{ buttonText }}
        </span>
    </button>
</template>

<script>
import LoadingSpinner from '@/components/loading-spinner';
import { Actions } from '@/services/enums';

export default {
    name: 'SubmitButton',

    components: {
        LoadingSpinner,
    },

    props: {
        action: {
            type: String,
            required: true,
        },
        submitting: {
            type: Boolean,
            required: true,
        },
    },

    computed: {
        buttonText() {
            switch (this.action) {
                case Actions.Call:
                    return 'Schedule Call';
                case Actions.Question:
                    return 'Submit Question';
                case Actions.RemoteAppointment:
                    return 'Request Appointment';
                case Actions.DealershipAppointment:
                default:
                    return 'Schedule Appointment';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.submit-button {
    margin: 1rem 2rem 3rem;
    padding: 1rem 2rem;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    max-width: 28rem;
    border: none;
    background-color: $color-highlight;
    border-radius: $rounded;

    color: $color-font-light;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: $font-weight-semibold;
    font-size: 20px;
    cursor: pointer;
    user-select: none;
}
</style>
